var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g3, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCurrentDayCheckIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 71,
    viewBox: "0 0 75 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4979_624)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21773 5.60589V14.7671L1.75399 18.2406L1.59607 37.0206H73.2987V3.43994H47.7365L44.477 4.84823H5.33144L5.21773 5.60589Z",
    fill: "url(#paint0_linear_4979_624)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 62.884H16.2848L20.355 66.941H57.9382L61.5493 65.3186H73.7619V71.0001H17.9125L16.0132 69.1049H0V62.884Z",
    fill: "#FFB739"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8476 68.855H69.5044V58.3527L72.9555 54.9128V45.1051H73.2987V55.0555L69.8476 58.4954V68.855Z",
    fill: "#FFB739"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8988 33.9353H72.3553V45.1072H73.8988V33.9353Z",
    fill: "#FFB739"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04718 5.71082H5.39039V14.8091L1.93929 18.2469V28.0566H1.59607V18.1063L5.04718 14.6664V5.71082Z",
    fill: "#FFB739"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53939 28.0566H0.995972V39.2285H2.53939V28.0566Z",
    fill: "#FFB739"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93929 39.2264H1.59607V52.3313H1.93929V39.2264Z",
    fill: "#FFB739"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54798 0L1.05493 2.33176H2.8405L5.33144 0H3.54798Z",
    fill: "#FFB739"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55076 0L5.05981 2.33176H6.84327L9.33422 0H7.55076Z",
    fill: "#FFB739"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5536 0L9.06262 2.33176H10.8461L13.337 0H11.5536Z",
    fill: "#FFB739"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5563 0L13.0653 2.33176H14.8488L17.3418 0H15.5563Z",
    fill: "#FFB739"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5591 0L17.0681 2.33176H18.8537L21.3446 0H19.5591Z",
    fill: "#FFB739"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5639 0L21.073 2.33176H22.8565L25.3474 0H23.5639Z",
    fill: "#FFB739"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5668 0L25.0758 2.33176H26.8593L29.3502 0H27.5668Z",
    fill: "#FFB739"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5696 0L29.0786 2.33176H30.8621L33.353 0H31.5696Z",
    fill: "#FFB739"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5722 0L33.0813 2.33176H34.8669L37.3578 0H35.5722Z",
    fill: "#FFB739"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5772 0L37.0863 2.33176H38.8698L41.3607 0H39.5772Z",
    fill: "#FFB739"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5799 0L41.089 2.33176H42.8724L45.3634 0H43.5799Z",
    fill: "#FFB739"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1281 4.32768V20.4317L75 22.2996V2.28556H69.6917L67.464 0.0671387H49.8568L45.2939 4.61522L73.1281 4.32768Z",
    fill: "#FFB739"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9698 4.32776H0.907471V6.49161H45.9698V4.32776Z",
    fill: "#FFB739"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4979_624)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7413 62.2557V59.4283H61.7264V62.2557C61.7264 62.2729 61.7264 62.2915 61.7264 62.31C61.7305 64.9771 49.1665 65.0566 47.7338 65.0566C46.3012 65.0566 33.7372 64.9771 33.7372 62.31C33.7372 62.2915 33.7399 62.2742 33.7413 62.2557Z",
    fill: "#FFBB45"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7371 62.31C33.9082 64.9241 46.3107 65.0566 47.7338 65.0566C49.1568 65.0566 61.5539 64.8949 61.7263 62.2822C61.7263 62.2822 61.7263 62.5393 61.7263 62.5578C61.7263 65.2248 49.1623 65.3017 47.7297 65.3017C46.297 65.3017 33.733 65.2248 33.733 62.5578L33.7371 62.31Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4979_624",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 59,
    width: 29,
    height: 7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7413 62.2557V59.4283H61.7264V62.2557C61.7264 62.2729 61.7264 62.2915 61.7264 62.31C61.7305 64.9771 49.1665 65.0566 47.7338 65.0566C46.3012 65.0566 33.7372 64.9771 33.7372 62.31C33.7372 62.2915 33.7399 62.2742 33.7413 62.2557Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4979_624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 59.6536H61.5663V65.2897H62V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9998 59.6536H60.566V65.2897H60.9998V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 59.6536H59.5658V65.2897H59.9996V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9993 59.6536H58.5656V65.2897H58.9993V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9991 59.6536H57.5653V65.2897H57.9991V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9988 59.6536H56.5651V65.2897H56.9988V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9986 59.6536H55.5648V65.2897H55.9986V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9983 59.6536H54.5646V65.2897H54.9983V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9981 59.6536H53.5643V65.2897H53.9981V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9978 59.6536H52.5641V65.2897H52.9978V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9975 59.6536H51.5637V65.2897H51.9975V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9972 59.6536H50.5635V65.2897H50.9972V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.997 59.6536H49.5632V65.2897H49.997V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9967 59.6536H48.563V65.2897H48.9967V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.998 59.6536H47.5642V65.2897H47.998V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9976 59.6536H46.5638V65.2897H46.9976V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9974 59.6536H45.5636V65.2897H45.9974V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9971 59.6536H44.5634V65.2897H44.9971V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9969 59.6536H43.5631V65.2897H43.9969V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9966 59.6536H42.5629V65.2897H42.9966V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9964 59.6536H41.5626V65.2897H41.9964V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9961 59.6536H40.5624V65.2897H40.9961V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9959 59.6536H39.5621V65.2897H39.9959V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9956 59.6536H38.5619V65.2897H38.9956V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9954 59.6536H37.5616V65.2897H37.9954V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9952 59.6536H36.5614V65.2897H36.9952V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9949 59.6536H35.5612V65.2897H35.9949V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9947 59.6536H34.5609V65.2897H34.9947V59.6536Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9944 59.6536H33.5607V65.2897H33.9944V59.6536Z",
    fill: "#E3931B"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7338 62.1338C49.1665 62.1338 61.7305 62.0649 61.7305 59.7C61.7305 57.335 49.1665 57.2661 47.7338 57.2661C46.3012 57.2661 33.7372 57.3337 33.7372 59.7C33.7372 62.0663 46.3012 62.1338 47.7338 62.1338Z",
    fill: "#E3931B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7338 61.8689C49.1665 61.8689 61.7305 61.8 61.7305 59.4351C61.7305 57.0701 49.1665 57.0012 47.7338 57.0012C46.3012 57.0012 33.7372 57.0688 33.7372 59.4351C33.7372 61.8014 46.3012 61.8689 47.7338 61.8689Z",
    fill: "#FFE669"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7338 61.074C54.5359 61.074 60.0501 60.3402 60.0501 59.4351C60.0501 58.5299 54.5359 57.7961 47.7338 57.7961C40.9317 57.7961 35.4175 58.5299 35.4175 59.4351C35.4175 60.3402 40.9317 61.074 47.7338 61.074Z",
    fill: "#FFBB45"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7338 61.074C54.5359 61.074 60.0501 60.3402 60.0501 59.4351C60.0501 58.5299 54.5359 57.7961 47.7338 57.7961C40.9317 57.7961 35.4175 58.5299 35.4175 59.4351C35.4175 60.3402 40.9317 61.074 47.7338 61.074Z",
    fill: "#FFBB45"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7338 58.0743C41.2849 58.0743 35.9949 58.7368 35.4626 59.5741C35.4356 59.5347 35.42 59.4889 35.4175 59.4416C35.4175 58.5367 40.9318 57.8027 47.7324 57.8027C54.533 57.8027 60.0474 58.5367 60.0474 59.4416C60.0453 59.4888 60.0301 59.5345 60.0036 59.5741C59.4741 58.7341 54.1828 58.0743 47.7338 58.0743Z",
    fill: "#D98A14"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5885 60.6593V60.5016C45.3707 60.4857 44.3472 60.4393 43.544 60.3691C42.6491 60.2856 42.1962 60.1783 42.1962 60.0511C42.1962 59.8709 43.4058 59.7385 45.7935 59.6537L46.5885 59.6272V59.1065C45.5527 59.125 45.0478 59.1661 45.0478 59.2297V59.2535H42.608V59.227C42.608 59.1224 43.0774 59.0416 44.0037 58.9846C44.7098 58.9422 45.5787 58.9183 46.5885 58.913V58.7554H48.5411V58.917C51.5131 58.9554 53.0197 59.0998 53.0197 59.3476C53.0197 59.4589 52.6256 59.5516 51.8511 59.6245C51.2668 59.6788 50.3459 59.7305 49.098 59.7756L48.5411 59.7954V60.3108C49.3689 60.3002 49.9738 60.283 50.3446 60.2591C50.881 60.226 51.1409 60.1743 51.1409 60.1002V60.075H53.5916V60.1002C53.5916 60.2326 53.0224 60.3386 51.9017 60.4102C51.0178 60.4658 49.8875 60.4976 48.5411 60.5029V60.6593H46.5885ZM46.5885 59.8643C45.9755 59.8868 45.5212 59.9094 45.2352 59.9319C44.7809 59.969 44.5606 60.0154 44.5606 60.0763C44.5606 60.1373 44.7563 60.1955 45.1449 60.2366C45.4993 60.2737 45.9851 60.2962 46.5885 60.3068V59.8643ZM48.5411 59.5609C49.1883 59.5357 49.6604 59.5119 49.9478 59.4894C50.4239 59.4509 50.6538 59.4033 50.6538 59.3436C50.6538 59.2111 49.9696 59.1343 48.5411 59.1051V59.5609Z",
    fill: "#D98A14"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5885 60.3307V60.1731C45.3707 60.1572 44.3472 60.1108 43.544 60.0406C42.6491 59.9558 42.1962 59.8498 42.1962 59.7226C42.1962 59.5424 43.4058 59.4099 45.7935 59.3251L46.5885 59.2986V58.7766C45.5527 58.7965 45.0478 58.8362 45.0478 58.9011V58.925H42.608V58.9011C42.608 58.7965 43.0774 58.7143 44.0037 58.6587C44.7098 58.6163 45.5787 58.5924 46.5885 58.5871V58.4321H48.5411V58.5938C51.5131 58.6322 53.0197 58.7766 53.0197 59.023C53.0197 59.1357 52.6256 59.2284 51.8511 59.3013C51.2668 59.3556 50.3459 59.4059 49.098 59.4523L48.5411 59.4722V59.9862C49.3689 59.9756 49.9738 59.9597 50.3446 59.9359C50.881 59.9028 51.1409 59.8511 51.1409 59.7756V59.7517H53.5916V59.7756C53.5916 59.9081 53.0224 60.0154 51.9017 60.0869C51.0178 60.1426 49.8875 60.1744 48.5411 60.1784V60.336L46.5885 60.3307ZM46.5885 59.5358C45.9755 59.5583 45.5212 59.5808 45.2352 59.6033C44.7809 59.6391 44.5606 59.6868 44.5606 59.7464C44.5606 59.8061 44.7563 59.867 45.1449 59.9081C45.4993 59.9452 45.9851 59.9677 46.5885 59.977V59.5358ZM48.5411 59.2271C49.1883 59.2019 49.6604 59.1781 49.9478 59.1542C50.4239 59.1171 50.6538 59.0694 50.6538 59.0098C50.6538 58.8773 49.9696 58.7991 48.5411 58.7713V59.2271Z",
    fill: "#FFE669"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.806 63.011L18.1218 60.2631L45.3283 53.8943L46.0125 56.6421C46.0125 56.6594 46.0248 56.6766 46.0303 56.6951C46.6775 59.2867 34.4829 62.2213 33.0914 62.5473C31.6998 62.8732 19.4669 65.6568 18.8156 63.0693C18.8115 63.0468 18.8101 63.0282 18.806 63.011Z",
    fill: "#FFBB45"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8156 63.0693C19.6174 65.5707 31.7038 62.8759 33.0872 62.5526C34.4706 62.2293 46.4818 59.2443 46.0125 56.666C46.0125 56.666 46.0795 56.9151 46.0836 56.931C46.7322 59.5252 34.539 62.4598 33.1502 62.7858C31.7613 63.1117 19.523 65.8953 18.8758 63.3025L18.8156 63.0693Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4979_624",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 53,
    width: 29,
    height: 12
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.806 63.011L18.1218 60.2631L45.3283 53.8943L46.0125 56.6421C46.0125 56.6594 46.0248 56.6766 46.0303 56.6951C46.6775 59.2867 34.4829 62.2213 33.0914 62.5473C31.6998 62.8732 19.4669 65.6568 18.8156 63.0693C18.8115 63.0468 18.8101 63.0282 18.806 63.011Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4979_624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6423 54.0518L45.2207 54.1505L46.5884 59.6289L47.0101 59.5302L45.6423 54.0518Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6698 54.2801L44.2482 54.3788L45.6159 59.8571L46.0375 59.7585L44.6698 54.2801Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6987 54.508L43.2771 54.6067L44.6448 60.085L45.0665 59.9864L43.6987 54.508Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.725 54.7349L42.3033 54.8336L43.6711 60.312L44.0927 60.2133L42.725 54.7349Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7535 54.9628L41.3319 55.0615L42.6997 60.5399L43.1213 60.4412L41.7535 54.9628Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.781 55.191L40.3594 55.2897L41.7271 60.768L42.1487 60.6693L40.781 55.191Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8099 55.4177L39.3883 55.5164L40.7561 60.9947L41.1777 60.896L39.8099 55.4177Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.836 55.6458L38.4144 55.7445L39.7822 61.2229L40.2038 61.1242L38.836 55.6458Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8647 55.8725L37.4431 55.9712L38.8109 61.4496L39.2325 61.3509L37.8647 55.8725Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8935 56.0991L36.4719 56.1978L37.8397 61.6761L38.2613 61.5774L36.8935 56.0991Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9211 56.3272L35.4995 56.4259L36.8673 61.9043L37.2889 61.8056L35.9211 56.3272Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9486 56.5551L34.527 56.6538L35.8947 62.1322L36.3163 62.0335L34.9486 56.5551Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9762 56.7834L33.5546 56.8821L34.9223 62.3604L35.3439 62.2618L33.9762 56.7834Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0047 57.01L32.5831 57.1086L33.9509 62.587L34.3725 62.4883L33.0047 57.01Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0323 57.2382L31.6107 57.3369L32.9785 62.8153L33.4001 62.7166L32.0323 57.2382Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0598 57.4661L30.6382 57.5648L32.0059 63.0432L32.4275 62.9445L31.0598 57.4661Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0874 57.6929L29.6658 57.7916L31.0335 63.27L31.4551 63.1713L30.0874 57.6929Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.116 57.9196L28.6943 58.0183L30.0621 63.4967L30.4837 63.398L29.116 57.9196Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1435 58.1478L27.7219 58.2465L29.0897 63.7248L29.5113 63.6261L28.1435 58.1478Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.171 58.3757L26.7494 58.4744L28.1171 63.9527L28.5388 63.854L27.171 58.3757Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1986 58.6039L25.777 58.7026L27.1447 64.181L27.5663 64.0823L26.1986 58.6039Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2272 58.8305L24.8055 58.9292L26.1733 64.4076L26.5949 64.3089L25.2272 58.8305Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2534 59.0588L23.8318 59.1575L25.1995 64.6358L25.6211 64.5371L24.2534 59.0588Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2822 59.2867L22.8606 59.3854L24.2283 64.8637L24.65 64.765L23.2822 59.2867Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3098 59.5136L21.8882 59.6123L23.2559 65.0907L23.6775 64.992L22.3098 59.5136Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3387 59.7415L20.9171 59.8402L22.2849 65.3186L22.7065 65.2199L21.3387 59.7415Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3646 59.9685L19.943 60.0671L21.3107 65.5455L21.7324 65.4468L20.3646 59.9685Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3934 60.1964L18.9718 60.295L20.3395 65.7734L20.7612 65.6747L19.3934 60.1964Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.421 60.4245L17.9994 60.5232L19.3671 66.0016L19.7888 65.9029L18.421 60.4245Z",
    fill: "#E3931B"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3781 59.7094C39.8918 57.9507 45.7184 55.4658 45.3922 54.1593C45.066 52.8527 38.7105 53.2193 31.1968 54.978C23.6831 56.7367 17.8565 59.2216 18.1827 60.5282C18.5089 61.8347 24.8644 61.4682 32.3781 59.7094Z",
    fill: "#E3931B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3131 59.4504C39.8268 57.6917 45.6535 55.2068 45.3273 53.9002C45.0011 52.5937 38.6456 52.9603 31.1319 54.719C23.6182 56.4777 17.7915 58.9626 18.1177 60.2692C18.4439 61.5757 24.7994 61.2091 32.3131 59.4504Z",
    fill: "#FFE669"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1202 58.6777C38.7319 57.1301 43.9136 55.1623 43.694 54.2825C43.4743 53.4027 37.9365 53.9441 31.3248 55.4917C24.7131 57.0393 19.5313 59.007 19.751 59.8868C19.9706 60.7667 25.5085 60.2253 32.1202 58.6777Z",
    fill: "#FFBB45"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1202 58.6777C38.7319 57.1301 43.9136 55.1623 43.694 54.2825C43.4743 53.4027 37.9365 53.9441 31.3248 55.4917C24.7131 57.0393 19.5313 59.007 19.751 59.8868C19.9706 60.7667 25.5085 60.2253 32.1202 58.6777Z",
    fill: "#FFBB45"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3933 55.7637C25.125 57.2304 20.1429 59.076 19.8295 60.0127C19.7907 59.9769 19.7636 59.9308 19.7515 59.8802C19.5312 59.0005 24.7131 57.033 31.3249 55.4855C37.9366 53.938 43.4756 53.3974 43.6946 54.2825C43.7062 54.3309 43.7029 54.3816 43.685 54.4282C42.9639 53.7326 37.6657 54.2957 31.3933 55.7637Z",
    fill: "#D98A14"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9075 58.5355L30.8692 58.3818C29.6815 58.6468 28.6799 58.8323 27.8766 58.9422C26.9859 59.0641 26.5193 59.0641 26.4878 58.9422C26.444 58.766 27.5825 58.3632 29.8895 57.7419L30.6571 57.5352L30.5298 57.0277C29.5268 57.2808 29.0452 57.4345 29.0616 57.4967V57.5206L26.6971 58.0757V58.0519C26.6711 57.9499 27.1076 57.7644 27.9943 57.4994C28.6703 57.2967 29.5091 57.0754 30.4902 56.8369L30.4505 56.6819L32.3483 56.2368L32.388 56.3944C35.2861 55.7558 36.7845 55.5531 36.8447 55.7929C36.872 55.9016 36.5122 56.0817 35.776 56.3229C35.2218 56.5097 34.3338 56.7694 33.1365 57.0966L32.6001 57.2437L32.726 57.7432C33.5278 57.5444 34.1121 57.3894 34.4665 57.2834C34.9796 57.1297 35.2205 57.0185 35.2013 56.9469V56.9231L37.5822 56.3653V56.3891C37.615 56.5216 37.0882 56.7508 36.0168 57.0754C35.1712 57.3311 34.0806 57.6186 32.7725 57.93L32.8095 58.0824L30.9075 58.5355ZM30.7146 57.7617C30.1234 57.9234 29.6869 58.0479 29.4146 58.1353C28.9823 58.2745 28.7784 58.3699 28.7934 58.4295C28.8085 58.4891 29.0137 58.501 29.3996 58.452C29.754 58.407 30.2315 58.3195 30.8213 58.187L30.7146 57.7617ZM32.5385 57.0224C33.1611 56.8515 33.614 56.7203 33.8877 56.6329C34.3406 56.4872 34.5541 56.3891 34.539 56.3308C34.5076 56.1983 33.8152 56.2845 32.4277 56.5799L32.5385 57.0224Z",
    fill: "#D98A14"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.824 58.2161L30.7857 58.0624C29.598 58.3274 28.5963 58.5129 27.7918 58.6229C26.9024 58.7448 26.4358 58.7448 26.4043 58.6229C26.3605 58.4467 27.5058 58.0426 29.806 57.4225L30.5736 57.2158L30.4504 56.7097C29.4474 56.9654 28.9672 57.1191 28.9822 57.1814V57.2052L26.6177 57.7564V57.7325C26.5931 57.6305 27.0282 57.445 27.9163 57.1787C28.5909 56.9773 29.4297 56.7561 30.4108 56.5163L30.3724 56.3599L32.2703 55.9161L32.3086 56.0737C35.2067 55.4351 36.7064 55.2324 36.7666 55.4722C36.7926 55.5809 36.4341 55.7611 35.698 56.0022C35.1424 56.189 34.2558 56.4487 33.0585 56.7759L32.5221 56.9217L32.6466 57.4225C33.4416 57.2397 34.0259 57.0793 34.3816 56.9747C34.8948 56.8197 35.1356 56.7097 35.1178 56.6382V56.613L37.4987 56.0565V56.0804C37.5315 56.2129 37.0047 56.4421 35.9333 56.7653C35.0877 57.0224 33.9958 57.3086 32.6877 57.6212L32.726 57.7723L30.824 58.2161ZM30.6297 57.4424C30.0386 57.6027 29.6021 57.7286 29.3311 57.816C28.8987 57.9485 28.6949 58.0505 28.7099 58.1088C28.725 58.1671 28.9302 58.1817 29.3161 58.1326C29.6705 58.0876 30.148 58.0002 30.7378 57.8677L30.6297 57.4424ZM32.4578 56.7097C33.0817 56.5388 33.5346 56.4076 33.8083 56.3188C34.2612 56.1744 34.4733 56.0764 34.4596 56.0168C34.4268 55.8843 33.7358 55.9704 32.3469 56.2672L32.4578 56.7097Z",
    fill: "#FFE669"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M57.73 55.7056L58.0565 52.6564L29.6777 49.6177L29.3512 52.6668C29.3491 52.6868 29.3471 52.7054 29.345 52.7254C29.037 55.6017 41.767 57.0486 43.2195 57.2041C44.6721 57.3597 57.4199 58.6409 57.7278 55.7646C57.73 55.7446 57.7292 55.7257 57.73 55.7056Z",
    fill: "#FFBB45"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7281 55.7647C57.253 58.5638 44.6627 57.3587 43.2198 57.2042C41.7769 57.0497 29.226 55.5295 29.3488 52.6926C29.3488 52.6926 29.3191 52.9698 29.3169 52.9898C29.0089 55.8661 41.7389 57.313 43.1915 57.4686C44.6441 57.6241 57.3918 58.9053 57.6998 56.029L57.7281 55.7647Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4979_624",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 49,
    width: 30,
    height: 9
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57.73 55.7056L58.0565 52.6564L29.6777 49.6177L29.3512 52.6668C29.3491 52.6868 29.3471 52.7054 29.345 52.7254C29.037 55.6017 41.767 57.0486 43.2195 57.2041C44.6721 57.3597 57.4199 58.6409 57.7278 55.7646C57.73 55.7446 57.7292 55.7257 57.73 55.7056Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4979_624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8182 49.8784L29.3784 49.8313L28.7276 55.9096L29.1674 55.9567L29.8182 49.8784Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8324 49.987L30.3926 49.9399L29.7417 56.0182L30.1815 56.0653L30.8324 49.987Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8465 50.0956L31.4067 50.0485L30.7559 56.1268L31.1957 56.1739L31.8465 50.0956Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8607 50.2042L32.4209 50.1571L31.77 56.2354L32.2098 56.2825L32.8607 50.2042Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8749 50.3128L33.4351 50.2657L32.7842 56.344L33.224 56.3911L33.8749 50.3128Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.889 50.4214L34.4492 50.3743L33.7984 56.4526L34.2382 56.4997L34.889 50.4214Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9032 50.53L35.4634 50.4829L34.8125 56.5612L35.2523 56.6083L35.9032 50.53Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9173 50.6385L36.4775 50.5914L35.8267 56.6697L36.2665 56.7168L36.9173 50.6385Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9315 50.7472L37.4917 50.7001L36.8408 56.7784L37.2806 56.8255L37.9315 50.7472Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9441 50.8554L38.5043 50.8083L37.8534 56.8866L38.2932 56.9337L38.9441 50.8554Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9585 50.9642L39.5187 50.9171L38.8678 56.9954L39.3076 57.0425L39.9585 50.9642Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9726 51.0728L40.5328 51.0258L39.882 57.1041L40.3218 57.1511L40.9726 51.0728Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9868 51.1814L41.547 51.1343L40.8961 57.2126L41.3359 57.2597L41.9868 51.1814Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.001 51.29L42.5612 51.2429L41.9103 57.3212L42.3501 57.3683L43.001 51.29Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0152 51.3985L43.5754 51.3514L42.9246 57.4297L43.3644 57.4768L44.0152 51.3985Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0294 51.5072L44.5896 51.4601L43.9387 57.5384L44.3785 57.5855L45.0294 51.5072Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0433 51.6161L45.6035 51.569L44.9527 57.6473L45.3925 57.6944L46.0433 51.6161Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0575 51.7246L46.6177 51.6775L45.9668 57.7558L46.4066 57.8029L47.0575 51.7246Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.072 51.8327L47.6322 51.7856L46.9813 57.8639L47.4211 57.911L48.072 51.8327Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.086 51.9416L48.6462 51.8945L47.9954 57.9728L48.4352 58.0199L49.086 51.9416Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1002 52.0501L49.6604 52.0031L49.0095 58.0813L49.4493 58.1284L50.1002 52.0501Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1144 52.1588L50.6746 52.1117L50.0237 58.19L50.4635 58.2371L51.1144 52.1588Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1285 52.2673L51.6887 52.2202L51.0379 58.2985L51.4777 58.3456L52.1285 52.2673Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1427 52.376L52.7029 52.3289L52.052 58.4072L52.4918 58.4542L53.1427 52.376Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1568 52.4846L53.717 52.4375L53.0662 58.5158L53.506 58.5629L54.1568 52.4846Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.171 52.5931L54.7312 52.546L54.0803 58.6243L54.5201 58.6714L55.171 52.5931Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1852 52.7018L55.7454 52.6547L55.0945 58.733L55.5343 58.7801L56.1852 52.7018Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1994 52.8103L56.7596 52.7632L56.1088 58.8415L56.5486 58.8886L57.1994 52.8103Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2121 52.9188L57.7723 52.8717L57.1215 58.95L57.5613 58.9971L58.2121 52.9188Z",
    fill: "#E3931B"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5567 54.0549C51.3944 54.8942 57.874 54.3994 58.0292 52.9497C58.1844 51.5001 51.9565 49.6446 44.1188 48.8054C36.2811 47.9661 29.8015 48.4609 29.6463 49.9106C29.4911 51.3602 35.719 53.2157 43.5567 54.0549Z",
    fill: "#E3931B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5873 53.7692C51.425 54.6084 57.9046 54.1136 58.0598 52.664C58.2151 51.2143 51.9872 49.3588 44.1494 48.5196C36.3117 47.6803 29.8322 48.1752 29.677 49.6248C29.5217 51.0744 35.7496 52.9299 43.5873 53.7692Z",
    fill: "#FFE669"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6792 52.9119C50.576 53.6504 56.2517 53.4578 56.3562 52.4816C56.4607 51.5055 50.9545 50.1155 44.0577 49.377C37.1609 48.6385 31.4852 48.8311 31.3807 49.8073C31.2762 50.7834 36.7824 52.1734 43.6792 52.9119Z",
    fill: "#FFBB45"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6792 52.9119C50.576 53.6504 56.2517 53.4578 56.3562 52.4816C56.4607 51.5055 50.9545 50.1155 44.0577 49.377C37.1609 48.6385 31.4852 48.8311 31.3807 49.8073C31.2762 50.7834 36.7824 52.1734 43.6792 52.9119Z",
    fill: "#FFBB45"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 49.6784C50.5641 50.3786 55.8525 51.6675 56.2957 52.6269C56.3286 52.5851 56.3495 52.5348 56.3561 52.4816C56.4606 51.5057 50.9543 50.1154 44.0576 49.3769C37.161 48.6385 31.4865 48.8315 31.382 49.8074C31.3776 49.861 31.3879 49.9147 31.4117 49.9623C32.0471 49.1141 37.4867 48.9783 44.0254 49.6784Z",
    fill: "#D98A14"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9085 52.3769L42.9265 52.2083C41.5613 52.0622 40.4197 51.8994 39.5298 51.7435C38.4018 51.5446 37.838 51.3715 37.8536 51.2258L37.8565 51.1986L40.3399 51.4646L40.337 51.4917C40.3284 51.5717 40.5875 51.6558 41.1275 51.7498C41.4993 51.8156 42.1119 51.9 42.9487 52.0012L43.0082 51.4453L42.4458 51.3634C41.1913 51.18 40.2594 51.0238 39.6733 50.9018C38.8951 50.739 38.5076 50.5963 38.5204 50.4763C38.5489 50.2105 40.0925 50.2111 43.1097 50.498L43.1283 50.3237L45.1081 50.5357L45.0896 50.7086C46.1135 50.8182 46.9925 50.9441 47.7021 51.0664C48.6347 51.2284 49.1019 51.3608 49.0892 51.4794L49.0864 51.5051L46.6141 51.2404L46.617 51.2132C46.6244 51.1446 46.1172 51.0455 45.0677 50.9129L45.0074 51.4759L45.8118 51.5909C48.2222 51.9357 49.4347 52.2101 49.4133 52.4101C49.398 52.553 48.9256 52.6137 48.0087 52.6066C47.1857 52.5994 46.1426 52.5383 44.9064 52.4189L44.8882 52.5889L42.9085 52.3769ZM44.9291 52.2074C45.5434 52.2631 46.0428 52.2906 46.4023 52.2886C46.7995 52.2878 47.0042 52.2504 47.0118 52.179C47.0195 52.1075 46.8008 52.0393 46.3445 51.95C46.0585 51.8948 45.5991 51.821 44.9802 51.7302L44.9291 52.2074ZM43.0881 50.6995C41.6432 50.5766 40.9407 50.5852 40.9254 50.728C40.9185 50.7923 41.1474 50.8689 41.6244 50.9619C41.9132 51.0174 42.3889 51.0958 43.0424 51.1917L43.0881 50.6995Z",
    fill: "#D98A14"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9464 52.0227L42.9637 51.8612C41.5985 51.715 40.4569 51.5523 39.567 51.3964C38.439 51.1975 37.8754 51.023 37.8908 50.8787L37.8937 50.8515L40.3771 51.1175L40.3742 51.1446C40.3656 51.2246 40.6247 51.3087 41.1647 51.4027C41.5365 51.4685 42.1491 51.5529 42.9859 51.654L43.0462 51.0911L42.4838 51.0092C41.2293 50.8257 40.2974 50.6696 39.7112 50.5476C38.933 50.3847 38.5456 50.2421 38.5584 50.1221C38.587 49.8549 40.1304 49.8568 43.1476 50.1438L43.1663 49.9694L45.1461 50.1814L45.1271 50.3586C46.151 50.4682 47.03 50.5942 47.7396 50.7164C48.6722 50.8784 49.1394 51.0108 49.1267 51.1294L49.1239 51.1551L46.6516 50.8904L46.6544 50.8647C46.6617 50.7961 46.1545 50.697 45.1051 50.5644L45.0448 51.1273L45.8492 51.2424C48.2596 51.5872 49.4721 51.8615 49.4507 52.0616C49.4354 52.2045 48.963 52.2652 48.046 52.258C47.223 52.2508 46.1799 52.1897 44.9438 52.0704L44.9256 52.2404L42.9464 52.0227ZM44.9671 51.8532C45.5815 51.9074 46.0808 51.9363 46.4402 51.9343C46.8376 51.9321 47.0421 51.8962 47.0498 51.8247C47.0574 51.7533 46.8388 51.6851 46.3825 51.5957C46.0965 51.5406 45.6371 51.4668 45.0182 51.3759L44.9671 51.8532ZM43.126 50.3452C41.6812 50.2223 40.9786 50.2309 40.9633 50.3738C40.9565 50.4381 41.1854 50.5146 41.6624 50.6076C41.9511 50.6631 42.427 50.7401 43.0803 50.8375L43.126 50.3452Z",
    fill: "#FFE669"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4979_624",
    x1: 37.4484,
    y1: -0.245536,
    x2: 37.4484,
    y2: 30.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26253F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4979_624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 71,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4979_624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 13,
    fill: "white",
    transform: "translate(18 53)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrentDayCheckIn);
export default __webpack_public_path__ + "static/media/iconCurrentDayCheckIn.f8ff47ab0750e76def414de5d6fbc9eb.svg";
export { ForwardRef as ReactComponent };